export default __webpack_public_path__ + "static/media/ExerciseParadox.baf7b3a7.jpg";